import React from "react";
import Container from "../Common/Container";
import Button from "../primitives/Button";
import { Item, PricingProps } from "./interfaces/Pricing";
import parse from "html-react-parser";
import Text from "../Common/Text";
const DEFAULDATA = {
  title: { value: "Escoge El Mejor Plan Para Ti.\n" },
  description: {
    value: "Tenemos un planes para cada una de tus necesidades\n\n",
  },
  items: [
    {
      id: "cc1d9c7c-61ae-33e6-7dfb-841e7da6b5a5",
      title: { value: "Básico" },
      description: { value: "Ideal para emprendedores" },
      button: { name: "PROBAR AHORA", url: "#" },
      price: "$74.900",
      peer: " / mes",
      charactericts:
        '<p style="line-height: 1;"><span class="elementor-icon-list-text">Almacenamiento ilimitado</span></p>\n<p style="line-height: 1;"><span class="elementor-icon-list-text">Capacitaci&oacute;n y Soporte</span></p>\n<p style="line-height: 1;"><span class="elementor-icon-list-text">Sistema de inventarios</span></p>\n<p style="line-height: 1;"><span class="elementor-icon-list-text">Usuarios Ilimitados</span></p>',
    },
    {
      id: "8f95f311-8826-c7f5-2cbc-95abf45f8eef",
      title: { value: "Profesional" },
      description: { value: "Ideal para PYMES" },
      button: { name: "PROBAR AHORA", url: "#" },
      price: "$89.900",
      peer: "/ mes",
      charactericts:
        '<p style="line-height: 1;"><span class="elementor-icon-list-text">Almacenamiento ilimitado</span></p>\n<p style="line-height: 1;"><span class="elementor-icon-list-text">Capacitaci&oacute;n y Soporte</span></p>\n<p style="line-height: 1;"><span class="elementor-icon-list-text">Sistema de inventarios</span></p>\n<p style="line-height: 1;"><span class="elementor-icon-list-text">Usuarios Ilimitados</span></p>',
    },
    {
      id: "61a6a3fe-2b91-46ea-7234-217730aabda4",
      title: { value: "Empresarial" },
      description: { value: "Ideal para todo tipo de negocio" },
      button: { name: "PROBAR AHORA", url: "#" },
      price: "Contactanos",
      charactericts:
        '<p style="line-height: 1;"><span class="elementor-icon-list-text">Almacenamiento ilimitado</span></p>\n<p style="line-height: 1;"><span class="elementor-icon-list-text">Capacitaci&oacute;n y Soporte</span></p>\n<p style="line-height: 1;"><span class="elementor-icon-list-text">Sistema de inventarios</span></p>\n<p style="line-height: 1;"><span class="elementor-icon-list-text">Usuarios Ilimitados</span></p>',
    },
  ],
};
const Pricing = ({
  data = DEFAULDATA,
  onChange,
}: {
  data: PricingProps;
  onChange?: (value: any, id?: string) => void;
}) => {
  return (
    <Container className="mt-10">
      <div className="flex flex-wrap -mx-4">
        <div className="w-full px-4">
          <div className="text-center mx-auto mb-[60px] lg:mb-10 max-w-[510px]">
            <Text
              editor={!!onChange}
              id="Products"
              onChange={(val: any) => onChange?.(val, "title")}
            >
              {data?.title}
            </Text>
          </div>
        </div>
      </div>
      <div className={`justify-center gap-4  flex flex-wrap`}>
        {data?.items?.map((item) => (
          <Card key={item.id} item={item} onChange={onChange} data={data} />
        ))}
      </div>
    </Container>
  );
};

const Card = ({
  item,
  onChange,
  data,
}: {
  item: Item;
  onChange?: (value: any, id?: string) => void;
  data: PricingProps;
}) => {
  return (
    <div
      className="
               bg-white
               rounded-xl
               relative
               z-10
               overflow-hidden
               border border-[--primary700] border-opacity-20
               shadow-pricing
               py-10
               px-8
               sm:p-12
               lg:py-10 lg:px-6
               xl:p-12
               mb-10
               grid
               w-[380px]
               "
    >
      <div>
        <Text
          editor={!!onChange}
          id="Pricing"
          onChange={(val: any) => {
            if (onChange) {
              let arr = data?.items;

              arr = arr?.map((x) => {
                if (x.id === item.id) {
                  return { ...x, title: val };
                }
                return x;
              });
              onChange?.(arr, "items");
            }
          }}
        >
          {item.title}
        </Text>
      </div>

      <Button
        {...item?.button}
        className="flex w-full self-end mt-3  justify-center"
      />
    </div>
  );
};
export default Pricing;
